import { Pipe, PipeTransform } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Pipe({
    name: 'errorMessage',
    pure: false
})
export class PipeErrorMessage implements PipeTransform {
    transform(field: any, formGroup:FormGroup, hasError: boolean = false): any {

        let control:any = null;

        if(field.indexOf('.') > -1){
            let part = field.split('.');
            control = formGroup.controls[part[0]]['controls'][part[1]];
        } else {
            control = formGroup.controls[field];
        }

        if(hasError)
            return control?.invalid;

        if (control?.errors?.required) {
            return 'Obrigatório';
        }
    
        if (control?.errors?.invalid) {
            return control.errors.msg;
        }
        
        return "Campo inválido";
    }
}